"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isClosureCommissionBackupEvent = exports.ClosureEventTypes = void 0;
var ClosureEventTypes;
(function (ClosureEventTypes) {
    ClosureEventTypes["UPDATE_CUSTOMER_ASSETS"] = "UPDATE_CUSTOMER_ASSETS";
    ClosureEventTypes["CLOSURE_COMMISSIONS_BACKUP"] = "CLOSURE_COMMISSIONS_BACKUP";
})(ClosureEventTypes = exports.ClosureEventTypes || (exports.ClosureEventTypes = {}));
const isClosureCommissionBackupEvent = (event) => {
    return event.type === ClosureEventTypes.CLOSURE_COMMISSIONS_BACKUP;
};
exports.isClosureCommissionBackupEvent = isClosureCommissionBackupEvent;
